export default __webpack_public_path__ + "static/media/misc-closet2-480w.4f5e8932.avif";